"use client";

import { Accordion } from "@heroui/react";
import { ChevronDown } from "lucide-react";

type FaqItem = {
  title: string;
  content: string;
};

type FaqAccordionClientProps = {
  items: FaqItem[];
};

export default function FaqAccordionClient({ items }: FaqAccordionClientProps) {
  return (
    <Accordion className="container w-full">
      {items.map((item, index) => (
        <Accordion.Item
          key={item.title}
          className="after:bg-gray-300 dark:after:bg-gray-700"
        >
          <Accordion.Heading>
            <Accordion.Trigger className="group focus-visible:ring-primary-700 flex w-full items-center gap-3 px-0 py-5 text-start hover:bg-transparent focus-visible:rounded-sm focus-visible:ring-2 focus-visible:outline-none data-[hovered=true]:bg-transparent dark:focus-visible:ring-slate-200">
              <span className="font-kufi text-primary-700 group-hover:text-primary-800 group-focus-visible:text-primary-800 text-sm leading-none font-bold transition-colors dark:text-white dark:group-hover:text-slate-200 dark:group-focus-visible:text-slate-200">
                {index.toString().padStart(2, "0")}
              </span>
              <span className="text-primary-700 group-hover:text-primary-800 group-focus-visible:text-primary-800 m-3 flex-1 text-sm leading-none font-bold tracking-tight transition-colors dark:text-white dark:group-hover:text-slate-200 dark:group-focus-visible:text-slate-200">
                {item.title}
              </span>
              <Accordion.Indicator className="text-primary-700 group-hover:text-primary-800 group-focus-visible:text-primary-800 transition-transform duration-200 data-[expanded=true]:rotate-180 dark:group-hover:text-slate-200 dark:group-focus-visible:text-slate-200">
                <ChevronDown aria-hidden="true" />
              </Accordion.Indicator>
            </Accordion.Trigger>
          </Accordion.Heading>
          <Accordion.Panel>
            <Accordion.Body className="text-muted text-sm leading-7">
              {item.content}
            </Accordion.Body>
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
